<template>
  <div>
    <b-table-simple
      v-if="profile_matters_evaluations.length > 0 || allows_crud"
      small
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th
            :colspan="tableColspan"
            style="text-align: center"
            class="pl-3 evaluation-header"
          >
            {{
              $t(
                "matterProgram.matterProgramView.activitiesAndEvaluations"
              ).toUpperCase()
            }}
            <div class="evaluation-button-div">
              <div class="d-flex">
                <ContainerButtonsDownload
                  v-if="
                    allows_crud &&
                    institution &&
                    institution.internal_use_id != 'duoc.cl' &&
                    user &&
                    user.is_superuser
                  "
                  :id_button="`col-display-1-evaluation-${egress_profile_matter_id}`"
                  :tooltip_text="''"
                  class=""
                  :text_button="
                    $t('matterProgram.matterProgramView.copyEvaluations')
                  "
                >
                  <template #popover-container-buttons>
                    <div>
                      <ButtonMedium
                        v-if="
                          allows_crud &&
                          can_update &&
                          availableTargetEpms.length > 0
                        "
                        :tooltip_text="``"
                        :click_button="
                          () =>
                            $bvModal.show(
                              `copy-epm-epm-modal-${egress_profile_matter_id}`
                            )
                        "
                        :text_button="
                          $t(
                            'matterProgram.matterProgramView.copyEpmEpmModalTitle',
                            {
                              entity: $getVisibleNames(
                                'mesh.egressprofile',
                                false,
                                'Perfil de Egreso'
                              ),
                            }
                          )
                        "
                        :custom_class="`w-100 mb-1 text-left`"
                        :icon="'files'"
                        :variant="'primary'"
                      >
                      </ButtonMedium>
                      <ButtonMedium
                        v-if="allows_crud && can_update"
                        :tooltip_text="``"
                        :click_button="openEpmMatterModal"
                        :text_button="
                          $t(
                            'matterProgram.matterProgramView.copyEpmMatterModalTitle',
                            {
                              entity: $getVisibleNames(
                                'teaching.matter',
                                false,
                                'Asignatura Base'
                              ),
                            }
                          )
                        "
                        :custom_class="`w-100 text-left`"
                        :icon="'files'"
                        :variant="'primary'"
                      >
                      </ButtonMedium>
                    </div>
                  </template>
                </ContainerButtonsDownload>
                <ButtonMedium
                  v-if="allows_crud && can_update"
                  :tooltip_text="``"
                  :click_button="
                    () =>
                      $bvModal.show(
                        `add-evaluation-modal-${egress_profile_matter_id}`
                      )
                  "
                  :text_button="
                    $t(
                      'matterProgram.matterProgramView.createActivityOrEvaluation'
                    )
                  "
                  :custom_class="`mx-1`"
                  :icon="'plus'"
                  :variant="'primary'"
                >
                </ButtonMedium>
                <!-- <b-button
                v-if="allows_crud"
                class="mx-1"
                size="sm"
                @click="
                  $bvModal.show(
                    `add-evaluation-modal-${egress_profile_matter_id}`
                  )
                "
                >Crear Actividad o Evaluación</b-button
              > -->
              </div>
            </div>
          </b-th>
        </b-tr>
        <b-tr>
          <b-td
            style="width: 2%"
            class="text-center"
            v-if="allows_crud && profile_matters_evaluations.length > 0"
          >
          </b-td>
          <b-td class="text-center print-nombre">
            <strong> {{ $t("reusable.common.name").toUpperCase() }} </strong>
          </b-td>
          <b-td
            v-if="
              institution &&
              institution.internal_use_id != 'duoc.cl' &&
              institution.kl_assessment
            "
            class="text-center print-instrumento"
          >
            <strong>
              {{
                $getVisibleNames(
                  "evaluations2.test",
                  true,
                  "Instrumentos"
                ).toUpperCase()
              }}
            </strong>
          </b-td>
          <b-td
            v-if="isDuocInstitution"
            style="width: 20%; min-width: 300px"
            class="text-center print-descripcion"
          >
            <strong>
              {{ $t("reusable.common.description").toUpperCase() }}
            </strong>
          </b-td>
          <b-td class="text-center print-tipo">
            <strong>
              {{ $t("matterProgram.matterProgramView.type").toUpperCase() }}
            </strong>
          </b-td>
          <b-td class="text-center print-ponderacion">
            <strong>{{
              $t("matterProgram.matterProgramView.weighing").toUpperCase()
            }}</strong>
          </b-td>
          <b-td
            v-if="showEvaluationContentColumn && canViewEvaluations"
            class="text-center print-contenido"
          >
            <strong>
              {{
                $t("matterProgram.matterProgramView.hasContent").toUpperCase()
              }}
            </strong>
          </b-td>
          <b-td
            colspan="1"
            class="text-center print-criterios"
            v-if="
              institution &&
              institution.show_evaluation_criteria_macro &&
              canViewEvaluations
            "
          >
            <strong>
              {{
                $getVisibleNames(
                  "teaching.evaluationcriteriamacro",
                  true,
                  "Criterios de Evaluación Macro"
                ).toUpperCase()
              }}</strong
            >
          </b-td>
          <b-td
            v-if="canViewEvaluations"
            colspan="1"
            class="text-center print-criterios criterios-micro-column"
          >
            <strong>
              {{
                $getVisibleNames(
                  "teaching.evaluationcriteriamicro",
                  true,
                  "Criterios de Evaluación Micro"
                ).toUpperCase()
              }}</strong
            >
          </b-td>
          <b-td
            style="width: 2%"
            v-if="allows_crud && profile_matters_evaluations.length > 0"
          ></b-td>
        </b-tr>
      </b-thead>
      <template v-for="item in filterLearningExperience">
        <template
          v-if="
            profile_matters_evaluations.filter(
              (x) => x.learning_experience == item.id
            ).length > 0
          "
        >
          <b-thead :key="'learning-experiences-1' + item.id">
            <b-tr>
              <b-th
                style="text-align: left"
                class="pl-3 evaluation-header"
                :colspan="tableColspan"
                >{{ item.name }}</b-th
              >
            </b-tr>
          </b-thead>
          <EPMatterProgramEvaluationDraggable
            :key="'learning-experiences-2' + item.id + tmp_key"
            :allows_crud="allows_crud"
            :learning_experience="item.id"
            :mattersEvaluations="profile_matters_evaluations"
            :egress_profile_matter_id="egress_profile_matter_id"
            :matter_id="matter.matter"
            :EvaluationSituations="evaluation_situations"
            :EPMatEvaStuEnvTimAll="ep_mat_eva_stu_env_tim_all"
            :can_delete="can_delete"
            :can_update="can_update"
            :EvaluationsStatus="evaluationsStatus"
            :show_evaluation_content="showEvaluationContentColumn"
            @fetch_ep_mat_eva_stu_env_tim_all="fetchEpMatEvaStuEnvTimAll"
            @created_support_resource="createdSupportResource"
            @delete_profile_matters_evaluation="deleteProfileMatterEvaluation"
          ></EPMatterProgramEvaluationDraggable>
        </template>
      </template>
      <template
        v-if="
          profile_matters_evaluations.filter(
            (x) => x.learning_experience == null && x.type != 5
          ).length > 0
        "
      >
        <b-thead
          :key="'learning-experiences-2' + null"
          v-if="filterLearningExperience.length > 0"
        >
          <b-tr>
            <b-th
              style="text-align: left"
              class="p-3 evaluation-header"
              :colspan="tableColspan"
            ></b-th>
          </b-tr>
        </b-thead>
        <EPMatterProgramEvaluationDraggable
          :key="'learning-experiences-2' + null + tmp_key"
          :allows_crud="allows_crud"
          :learning_experience="null"
          :mattersEvaluations="profile_matters_evaluations"
          :egress_profile_matter_id="egress_profile_matter_id"
          :include_transversal_evaluation="false"
          :matter_id="matter.matter"
          :EvaluationSituations="evaluation_situations"
          :EPMatEvaStuEnvTimAll="ep_mat_eva_stu_env_tim_all"
          :can_delete="can_delete"
          :can_update="can_update"
          :EvaluationsStatus="evaluationsStatus"
          :show_evaluation_content="showEvaluationContentColumn"
          @fetch_ep_mat_eva_stu_env_tim_all="fetchEpMatEvaStuEnvTimAll"
          @created_support_resource="createdSupportResource"
          @delete_profile_matters_evaluation="deleteProfileMatterEvaluation"
        ></EPMatterProgramEvaluationDraggable>
      </template>
      <b-tr
        v-if="
          institution &&
          (institution.internal_use_id == 'duoc.cl' ||
            institution.apply_transversal_exam_calculation) &&
          profile_matters_evaluations.length > 0
        "
      >
        <b-td class="p-3 text-right" :colspan="tableColspan">
          <strong>{{
            $t("matterProgram.matterProgramView.totalOfSubject", {
              percent: transversalExam
                ? 100 - parseFloat(transversalExam.weighing)
                : 60,
            }).toUpperCase()
          }}</strong>
        </b-td>
      </b-tr>
      <template
        v-if="
          profile_matters_evaluations.filter(
            (x) => x.learning_experience == null && x.type == 5
          ).length > 0
        "
      >
        <b-thead
          :key="'learning-experiences-3' + null"
          v-if="filterLearningExperience.length > 0"
        >
          <b-tr>
            <b-th
              style="text-align: left"
              class="p-3 evaluation-header"
              :colspan="tableColspan"
            ></b-th>
          </b-tr>
        </b-thead>
        <EPMatterProgramEvaluationDraggable
          :key="'learning-experiences-3' + null + tmp_key"
          :allows_crud="allows_crud"
          :learning_experience="null"
          :mattersEvaluations="profile_matters_evaluations"
          :egress_profile_matter_id="egress_profile_matter_id"
          :include_transversal_evaluation="true"
          :matter_id="matter.matter"
          :EvaluationSituations="evaluation_situations"
          :EPMatEvaStuEnvTimAll="ep_mat_eva_stu_env_tim_all"
          :can_delete="can_delete"
          :can_update="can_update"
          :EvaluationsStatus="evaluationsStatus"
          :show_evaluation_content="showEvaluationContentColumn"
          @fetch_ep_mat_eva_stu_env_tim_all="fetchEpMatEvaStuEnvTimAll"
          @created_support_resource="createdSupportResource"
          @delete_profile_matters_evaluation="deleteProfileMatterEvaluation"
        ></EPMatterProgramEvaluationDraggable>
        <b-tr
          v-if="
            institution &&
            (institution.internal_use_id == 'duoc.cl' ||
              institution.apply_transversal_exam_calculation) &&
            transversalExam
          "
        >
          <b-td class="p-3 text-right" :colspan="tableColspan">
            <strong>{{
              $t("matterProgram.matterProgramView.totalOfSubject", {
                percent: transversalExam.weighing,
              }).toUpperCase()
            }}</strong>
          </b-td>
        </b-tr>
      </template>
      <b-tbody v-if="profile_matters_evaluations.length == 0">
        <b-tr>
          <b-td class="text-center" :colspan="tableColspan">{{
            $t(
              "matterProgram.matterProgramView.noActivitiesOrEvaluationsToShow"
            )
          }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <ILIndicatorsUsage
      v-if="
        canViewEvaluations &&
        matter &&
        (profile_matters_evaluations.length > 0 || allows_crud) &&
        institution &&
        institution.internal_use_id != 'duoc.cl' &&
        institution.kl_assessment
      "
      :key="evaluation_ids.join(',')"
      :matter_id="matter.matter"
      :evaluations_ids="evaluation_ids"
      :fetch_evaluations="false"
      :fetch_evaluation_criteria_micro="false"
      :fetch_competence_unit="false"
      :show_taxonomy_color="true"
    ></ILIndicatorsUsage>
    <b-modal
      :id="`add-evaluation-modal-${egress_profile_matter_id}`"
      :title="$t('matterProgram.matterProgramView.createActivityOrEvaluation')"
      size="xl"
      hide-footer
    >
      <EPMatterProgramEvaluationForm
        :egress_profile_matter_id="egress_profile_matter_id"
        :evaluation_list="profile_matters_evaluations"
        :EvaluationSituations="evaluation_situations"
        :EPMatEvaStuEnvTimAll="ep_mat_eva_stu_env_tim_all"
        @fetch_ep_mat_eva_stu_env_tim_all="fetchEpMatEvaStuEnvTimAll"
        @created="createdEvaluation"
        @created_support_resource="createdSupportResource"
      >
      </EPMatterProgramEvaluationForm>
    </b-modal>
    <!-- Modal: EPM actual ↔ otro EPM (bidireccional) -->
    <CopyEvaluationsModal
      :modal_id="`copy-epm-epm-modal-${egress_profile_matter_id}`"
      :title="
        $t('matterProgram.matterProgramView.copyEpmEpmModalTitle', {
          entity: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      :description="
        $t('matterProgram.matterProgramView.copyEpmToEpmDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      :description_swapped="
        $t('matterProgram.matterProgramView.copyEpmFromEpmDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      description_variant="info"
      :swappable="true"
      :source_label="currentEpmProfileName"
      :target_label="copy_epm_id ? getEpmProfileName(copy_epm_id) : '—'"
      :source_evaluations="profile_matters_evaluations"
      :source_tests="allTests"
      :target_evaluations="other_epm_evaluations_preview"
      :target_tests="other_epm_preview_tests"
      :target_loading="is_loading_other_epm"
      :is_copying="is_copying"
      :epm_options="availableTargetEpmsOptions"
      :epm_selector_label="
        $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
      "
      :epm_selector_placeholder="
        $t('matterProgram.matterProgramView.selectTargetEpm', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
        })
      "
      @epm_selected="onEpmSelected"
      @confirmed="handleEpmEpmReplicate"
      @modal_hidden="
        copy_epm_id = null;
        other_epm_evaluations_preview = [];
        other_epm_preview_tests = [];
      "
    ></CopyEvaluationsModal>

    <!-- Modal: EPM actual ↔ Asignatura Base (bidireccional) -->
    <CopyEvaluationsModal
      :modal_id="`copy-epm-matter-modal-${egress_profile_matter_id}`"
      :title="
        $t('matterProgram.matterProgramView.copyEpmMatterModalTitle', {
          entity: $getVisibleNames('teaching.matter', false, 'Asignatura Base'),
        })
      "
      :description="
        $t('matterProgram.matterProgramView.copyEpmToMatterDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
          entityEpm: $getVisibleNames(
            'mesh.egressprofilematter',
            true,
            'Asignaturas'
          ),
        })
      "
      :description_swapped="
        $t('matterProgram.matterProgramView.copyMatterToEpmDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
        })
      "
      description_variant="warning"
      :swappable="true"
      :source_label="currentEpmProfileName"
      :target_label="
        $getVisibleNames('teaching.matter', false, 'Asignatura Base')
      "
      :source_evaluations="profile_matters_evaluations"
      :source_tests="allTests"
      :target_evaluations="matter_evaluations_preview"
      :target_tests="matter_preview_tests"
      :target_loading="is_loading_matter_preview"
      :is_copying="is_copying"
      @confirmed="handleEpmMatterReplicate"
    ></CopyEvaluationsModal>
  </div>
</template>

<script>
// import draggable from "vuedraggable";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { activityEvaluationType } from "@/utils/instructional_activity_types";
import {
  // generateUniqueId,
  toast,
} from "@/utils/utils";
export default {
  name: "EPMatterProgramEvaluation",
  props: {
    egress_profile_matter_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // draggable,
    EPMatterProgramEvaluationForm: () =>
      import("./EPMatterProgramEvaluationForm.vue"),
    EPMatterProgramEvaluationDraggable: () =>
      import("./EPMatterProgramEvaluationDraggable.vue"),
    // EPMEvaluationBibliographicResource: () =>
    //   import("./EPMEvaluationBibliographicResource.vue"),
    // SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    // ButtonWrapper: () => import("@/components/reusable/ButtonWrapper"),
    ILIndicatorsUsage: () =>
      import(
        "@/components/teaching/MatterProgram/Components/ILIndicatorsUsage"
      ),
    CopyEvaluationsModal: () =>
      import(
        "@/components/teaching/MatterProgram/Components/CopyEvaluationsModal"
      ),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ContainerButtonsDownload: () =>
      import("@/components/reusable/Buttons/ContainerButtonsDownload"),
  },
  data() {
    return {
      profile_matters_evaluations: [],
      evaluation_situations: [],
      ep_mat_eva_stu_env_tim_all: [],
      tmp_key: 0,
      // Copiar evaluaciones
      copy_epm_id: null,
      is_copying: false,
      other_epm_evaluations_preview: [],
      other_epm_preview_tests: [],
      is_loading_other_epm: false,
      matter_evaluations_preview: [],
      matter_preview_tests: [],
      is_loading_matter_preview: false,
      all_matter_epms: [],
      // Copiar evaluaciones
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      evaluationCriteriasMicros: names.EVALUATION_CRITERIAS,
      studyUnits: names.STUDY_UNITS,
      learningExperiences: names.LEARNING_EXPERIENCES,
      allTests: names.NEW_TESTS,
      redactionQuestions: names.NEW_REDACTION_QUESTIONS,
      multipleChoiceQuestions: names.NEW_MULTIPLE_CHOICE_QUESTIONS,
      matchingQuestions: names.NEW_MATCHING_QUESTIONS,
      rubricInstruments: names.NEW_RUBRIC_INSTRUMENTS,
      rubricCriterias: names.NEW_RUBRIC_CRITERIAS,
    }),
    // Profesores y estudiantes no acceden a las evaluaciones desde el
    // Programa de la Asignatura (solo perfiles con gestión de mallas/carrera).
    canViewEvaluations() {
      if (!this.user || !this.user.group_names) return false;
      return !(
        this.user.group_names.includes("PROFESORES") ||
        this.user.group_names.includes("ESTUDIANTES")
      );
    },
    // draggableList: {
    //   get() {
    //     let list = this.profile_matters_evaluations;
    //     list.sort(function (a, b) {
    //       if (a.order < b.order) return -1;
    //       if (a.order > b.order) return 1;
    //       return 0;
    //     });
    //     let order = 1;
    //     list.forEach((element) => {
    //       if (element.order != order) element.order = order;
    //       order += 1;
    //     });
    //     return list;
    //   },
    //   set(list) {
    //     let order = 1;
    //     list.forEach((element) => {
    //       if (element.order != order) {
    //         element.order = order;
    //         if (!isNaN(element.id)) {
    //           this.updatedEvaluation(element);
    //         }
    //       }
    //       order += 1;
    //     });
    //   },
    // },
    matter() {
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    filterLearningExperience() {
      if (!this.matter) return [];
      return this.learningExperiences.filter(
        (x) => x.matter == this.matter.matter
      );
    },
    evaluation_ids() {
      return this.profile_matters_evaluations
        .filter((x) => x.evaluation != null)
        .map((x) => x.evaluation);
    },
    transversalExam() {
      return this.profile_matters_evaluations.find((x) => x.type == 5);
    },
    // Columnas fijas: nombre, descripción, tipo y ponderación; el resto son
    // condicionales según institución y permisos.
    // Las columnas de contenido/uso de IL dependen de la data de evaluations2,
    // que sólo se carga (y tiene sentido) cuando la institución usa KL Assessment.
    showEvaluationContentColumn() {
      return Boolean(
        this.institution &&
          this.institution.internal_use_id != "duoc.cl" &&
          this.institution.kl_assessment
      );
    },
    // DUOC asigna un único Criterio de Evaluación Micro por pregunta/dimensión
    // (FK evaluation_criteria_micro); el resto usa el M2M evaluation_criterias_micro.
    isDuocInstitution() {
      return Boolean(
        this.institution && this.institution.internal_use_id == "duoc.cl"
      );
    },
    // Las preguntas de completar (filling) quedan fuera a propósito: la vista de
    // la evaluación tampoco las suma al puntaje del instrumento.
    allQuestions() {
      return []
        .concat(this.redactionQuestions)
        .concat(this.multipleChoiceQuestions)
        .concat(this.matchingQuestions);
    },
    // { [evaluation_id]: { applies, has_content, used_ecm_ids } }
    // applies: la evaluación tiene una Evaluación de evaluations2 asociada (las
    // Actividades, type 4, no la tienen y quedan como N/A).
    evaluationsStatus() {
      let status = {};
      this.profile_matters_evaluations.forEach((evaluation) => {
        status[evaluation.id] = this.getEvaluationStatus(evaluation);
      });
      return status;
    },
    tableColspan() {
      let colspan = 3;
      if (
        this.institution &&
        this.institution.internal_use_id != "duoc.cl" &&
        this.institution.kl_assessment
      )
        colspan += 1; // Instrumentos
      if (this.isDuocInstitution) colspan += 1; // Descripción
      if (this.showEvaluationContentColumn) colspan += 1; // Contenido
      if (this.institution && this.institution.show_evaluation_criteria_macro)
        colspan += 1; // Criterios de Evaluación Macro
      colspan += 1; // Criterios de Evaluación Micro
      if (this.allows_crud) colspan += 1; // Acciones
      if (this.allows_crud && this.can_update) colspan += 1; // Handle de arrastre
      return colspan;
    },
    availableTargetEpms() {
      return this.all_matter_epms.filter(
        (x) => x.id != this.egress_profile_matter_id && !x.use_matter_values
      );
    },
    availableTargetEpmsOptions() {
      return this.availableTargetEpms.map((epm) => {
        const profile = this.egressProfiles.find(
          (p) => p.id == epm.egress_profile
        );
        const profileName = profile
          ? profile.professional_title || profile.name
          : epm.name || `ID: ${epm.id}`;
        return {
          value: epm.id,
          text: profileName,
        };
      });
    },
    currentEpmProfileName() {
      if (!this.matter) return "";
      const profile = this.egressProfiles.find(
        (p) => p.id == this.matter.egress_profile
      );
      return profile ? profile.professional_title || profile.name : "";
    },
  },
  watch: {
    matter(newVal) {
      if (newVal && this.all_matter_epms.length === 0) {
        this.fetchAllMatterEpms();
      }
    },
  },
  methods: {
    // Criterios de Evaluación Micro asignados a una pregunta o dimensión de pauta.
    getItemECMicroIds(item) {
      if (this.isDuocInstitution)
        return item.evaluation_criteria_micro != null
          ? [item.evaluation_criteria_micro]
          : [];
      return item.evaluation_criterias_micro || [];
    },
    // Un instrumento está completo cuando su contenido cubre el total definido:
    // - preguntas: la suma de sus puntajes iguala el puntaje del instrumento.
    // - pautas: la suma de las ponderaciones de sus dimensiones es 100%.
    isTestComplete(test, questions, rubrics, rubric_criterias) {
      const test_questions = questions.filter((x) => x.test == test.id);
      const test_rubrics = rubrics.filter((x) => x.test == test.id);
      if (test_questions.length == 0 && test_rubrics.length == 0) return false;
      if (test_questions.length > 0) {
        const questions_max_score = this.$round(
          test_questions.reduce(
            (acc, x) => acc + parseFloat(x.max_score || 0),
            0
          )
        );
        if (
          !(parseFloat(test.max_score) > 0) ||
          questions_max_score != this.$round(parseFloat(test.max_score))
        )
          return false;
      }
      if (test_rubrics.length > 0) {
        // En la práctica es una pauta por instrumento, pero si hubiera más se
        // exigen todas completas en vez de mirar sólo la primera.
        const rubrics_are_complete = test_rubrics.every((rubric) => {
          const criterias = rubric_criterias.filter(
            (x) => x.rubric == rubric.id
          );
          if (criterias.length == 0) return false;
          const total_weighing = this.$round(
            criterias.reduce((acc, x) => acc + Number(x.weighing || 0), 0)
          );
          return total_weighing == 100;
        });
        if (!rubrics_are_complete) return false;
      }
      return true;
    },
    getEvaluationStatus(evaluation) {
      const empty = { applies: false, has_content: false, used_ecm_ids: [] };
      if (!this.showEvaluationContentColumn) return empty;
      if (evaluation.evaluation == null) return empty;
      const tests = this.allTests.filter(
        (x) => x.evaluation == evaluation.evaluation
      );
      const test_ids = tests.map((x) => x.id);
      const questions = this.allQuestions.filter((x) =>
        test_ids.includes(x.test)
      );
      const rubrics = this.rubricInstruments.filter((x) =>
        test_ids.includes(x.test)
      );
      const rubric_ids = rubrics.map((x) => x.id);
      const rubric_criterias = this.rubricCriterias.filter((x) =>
        rubric_ids.includes(x.rubric)
      );
      let used_ecm_ids = [];
      questions.forEach((question) => {
        used_ecm_ids = used_ecm_ids.concat(this.getItemECMicroIds(question));
      });
      rubric_criterias.forEach((rubric_criteria) => {
        used_ecm_ids = used_ecm_ids.concat(
          this.getItemECMicroIds(rubric_criteria)
        );
      });
      return {
        applies: true,
        has_content:
          tests.length > 0 &&
          tests.every((test) =>
            this.isTestComplete(test, questions, rubrics, rubric_criterias)
          ),
        used_ecm_ids: [...new Set(used_ecm_ids)],
      };
    },
    // Carga la data de evaluations2 necesaria para calcular el uso de Criterios
    // de Evaluación Micro y si la evaluación tiene contenido. La consume también
    // ILIndicatorsUsage, por eso se hace acá una sola vez.
    fetchEvaluationsContent(tests) {
      if (!this.showEvaluationContentColumn) return;
      const tests_ids = tests.map((x) => x.id);
      if (tests_ids.length == 0) return;
      this.$store.dispatch(names.FETCH_NEW_TEST_SEGMENTS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_REDACTION_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_MULTIPLE_CHOICE_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_MATCHING_QUESTIONS, {
        tests_ids: tests_ids,
      });
      // FETCH_NEW_RUBRIC_INSTRUMENTS despacha además la carga de las dimensiones
      // (NEW_RUBRIC_CRITERIAS) de cada pauta.
      this.$store.dispatch(names.FETCH_NEW_RUBRIC_INSTRUMENTS, {
        tests_ids: tests_ids,
      });
    },
    fetchAllMatterEpms() {
      if (!this.matter) return;
      this.$restful
        .GetAll(`/mesh/egress-profile-matter/?matter=${this.matter.matter}`)
        .then((response) => {
          this.all_matter_epms = response;
          const loadedProfileIds = this.egressProfiles.map((p) => p.id);
          const missingIds = [
            ...new Set(response.map((epm) => epm.egress_profile)),
          ].filter((id) => !loadedProfileIds.includes(id));
          missingIds.forEach((id) => {
            this.$store.dispatch(names.FETCH_EGRESS_PROFILE, id);
          });
        });
    },
    fetchOtherEpmEvaluations(epmId) {
      this.is_loading_other_epm = true;
      this.other_epm_evaluations_preview = [];
      this.$restful
        .GetAll(
          `/teaching/egress-profile-matter-evaluation/?egress_profile_matter=${epmId}`
        )
        .then((response) => {
          this.other_epm_evaluations_preview = response.sort(
            (a, b) => a.order - b.order
          );
          const evaluationIds = response
            .filter((x) => x.evaluation != null)
            .map((x) => x.evaluation);
          if (evaluationIds.length > 0) {
            this.$store
              .dispatch(names.FETCH_NEW_TESTS, {
                evaluations_ids: evaluationIds,
              })
              .then((tests) => {
                const existingIds = this.other_epm_preview_tests.map(
                  (t) => t.id
                );
                tests.forEach((t) => {
                  if (!existingIds.includes(t.id))
                    this.other_epm_preview_tests.push(t);
                });
              });
          }
        })
        .finally(() => {
          this.is_loading_other_epm = false;
        });
    },
    // Copiar evaluaciones – handler de selector de EPM
    onEpmSelected(epmId) {
      this.copy_epm_id = epmId;
      this.fetchOtherEpmEvaluations(epmId);
    },
    fetchMatterEvaluationsPreview() {
      if (!this.matter) return;
      this.is_loading_matter_preview = true;
      this.matter_evaluations_preview = [];
      this.matter_preview_tests = [];
      this.$restful
        .GetAll(`/teaching/matter-evaluation/?matter=${this.matter.matter}`)
        .then((response) => {
          this.matter_evaluations_preview = response.sort(
            (a, b) => a.order - b.order
          );
          const evaluationIds = response
            .filter((x) => x.evaluation != null)
            .map((x) => x.evaluation);
          if (evaluationIds.length > 0) {
            this.$store
              .dispatch(names.FETCH_NEW_TESTS, {
                evaluations_ids: evaluationIds,
              })
              .then((tests) => {
                const existingIds = this.matter_preview_tests.map((t) => t.id);
                tests.forEach((t) => {
                  if (!existingIds.includes(t.id))
                    this.matter_preview_tests.push(t);
                });
              });
          }
        })
        .finally(() => {
          this.is_loading_matter_preview = false;
        });
    },
    openEpmMatterModal() {
      this.fetchMatterEvaluationsPreview();
      this.$bvModal.show(
        `copy-epm-matter-modal-${this.egress_profile_matter_id}`
      );
    },
    getEpmProfileName(epmId) {
      const epm =
        this.egress_profiles_matters.find((x) => x.id == epmId) ||
        this.all_matter_epms.find((x) => x.id == epmId);
      if (!epm) return "";
      const profile = this.egressProfiles.find(
        (p) => p.id == epm.egress_profile
      );
      return profile ? profile.professional_title || profile.name : "";
    },
    // Copiar evaluaciones – llamadas al endpoint unificado
    handleEpmEpmReplicate({ source_items, target_updates, is_swapped }) {
      if (!this.copy_epm_id) return;
      this.is_copying = true;
      const payload = is_swapped
        ? {
            target_epm: this.egress_profile_matter_id,
            epm_evaluations_to_update: target_updates,
            epm_evaluations_to_replicate: source_items,
          }
        : {
            target_epm: this.copy_epm_id,
            epm_evaluations_to_update: target_updates,
            epm_evaluations_to_replicate: source_items,
          };
      this.$restful
        .Post("/mesh/replicate_evaluations/", payload)
        .then(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsSuccess")
          );
          this.fetchProfileMattersEvaluation();
          this.fetchEpMatEvaStuEnvTimAll();
          this.$bvModal.hide(
            `copy-epm-epm-modal-${this.egress_profile_matter_id}`
          );
        })
        .catch(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsError")
          );
        })
        .finally(() => {
          this.is_copying = false;
        });
    },
    handleEpmMatterReplicate({ source_items, target_updates, is_swapped }) {
      if (!this.matter) return;
      this.is_copying = true;
      const payload = is_swapped
        ? {
            target_epm: this.egress_profile_matter_id,
            epm_evaluations_to_update: target_updates,
            matter_evaluations_to_replicate: source_items,
          }
        : {
            target_matter: this.matter.matter,
            matter_evaluations_to_update: target_updates,
            epm_evaluations_to_replicate: source_items,
          };
      this.$restful
        .Post("/mesh/replicate_evaluations/", payload)
        .then(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsSuccess")
          );
          if (is_swapped) {
            this.fetchProfileMattersEvaluation();
            this.fetchEpMatEvaStuEnvTimAll();
          }
          this.$bvModal.hide(
            `copy-epm-matter-modal-${this.egress_profile_matter_id}`
          );
        })
        .catch(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsError")
          );
        })
        .finally(() => {
          this.is_copying = false;
        });
    },
    createdSupportResource(response) {
      this.$emit("created_support_resource", response);
    },
    deleteProfileMatterEvaluation(id) {
      const index = this.profile_matters_evaluations.findIndex(
        (x) => x.id == id
      );
      if (index != -1) {
        this.profile_matters_evaluations.splice(index, 1);
      }
    },
    createdNewEvaluation(response, tests_list) {
      this.$store
        .dispatch(names.POST_NEW_EVALUATION, {
          title: response.name,
          description: response.description,
          weighing: response.weighing,
          visible_by_evaluatees: false,
          parent_evaluation: null,
          files: [],
        })
        .then((new_evaluation) => {
          this.$store.commit(
            "MUTATE_CHANGE_NEW_EVALUATION_BY_EP_MATTER_EVALUATION",
            {
              new_evaluation_id: new_evaluation.id,
              egress_profile_matter_evaluation_id: response.id,
            }
          );
          this.$restful
            .Post("/evaluations2/evaluation-scope-default/", {
              scope: 2,
              scope_id: this.egress_profile_matter_id,
              evaluation: new_evaluation.id,
            })
            .then((evaluation_scope) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_SCOPE_BY_NEW_EVALUATION",
                evaluation_scope
              );
              response.evaluation = new_evaluation.id;
              this.$restful
                .Patch(
                  `/teaching/egress-profile-matter-evaluation/${response.id}/`,
                  { evaluation: new_evaluation.id }
                )
                .then(() => {
                  this.bulkCreateTest(tests_list, new_evaluation);
                });
              // evaluation_type:  diagnóstica 1, formativa 2, sumativa 3, actividad 4, transversal 5
              // evaluations2: sumativa 1, diagnóstica 2, formativa 3, trasnversal 4
              let evaluation_type = null;
              // diagnóstica 1 => diagnóstica 2
              if (response.type == 1) evaluation_type = 2;
              // formativa 2 => formativa 3
              else if (response.type == 2) evaluation_type = 3;
              // actividad 4: el tipo visible es "Actividad" y Formativa/Sumativa
              // es su subtipo, que se deduce de si pondera. Mismo criterio que
              // el "¿Posee Ponderación?" del Diseño Instruccional.
              else if (response.type == 4)
                evaluation_type = activityEvaluationType(response.weighing);
              // sumativa 3 => sumativa 1
              else if (response.type == 3) evaluation_type = 1;
              // trasnversal 5 => trasnversal 4
              else if (response.type == 5) evaluation_type = 4;
              // formativa 3
              else evaluation_type = 3;
              this.saveEvaluationTypeDefault(new_evaluation, {
                id: new_evaluation.evaluation_type_default,
                type: evaluation_type,
                evaluation: new_evaluation.id,
              });

              this.profile_matters_evaluations.push(response);
              this.$nextTick(() => {
                this.tmp_key += 1;
              });
              // this.$nextTick(() => {
              //   this.$bvModal.show(
              //     `epm-bibliographic-resource-modal-${response.id}`
              //   );
              // });
            });
        });
    },
    createdEvaluation(evaluation, tmp_ep_mat_eva_stu_env_tim_alls, tests_list) {
      evaluation.order =
        this.profile_matters_evaluations.filter(
          (x) => x.learning_experience == evaluation.learning_experience
        ).length + 1;
      this.$restful
        .Post(`/teaching/egress-profile-matter-evaluation/`, evaluation)
        .then((response) => {
          // El tipo "Actividad" ya no se salta la creacion del Evaluation: sin
          // el no hay donde colgar los Test ni a donde llevar el click de la
          // fila. Es lo que le da a la Actividad la misma funcionalidad que al
          // resto de las evaluaciones.
          if (response.evaluation == null) {
            this.createdNewEvaluation(response, tests_list);
          } else {
            this.profile_matters_evaluations.push(response);
            this.$nextTick(() => {
              this.tmp_key += 1;
            });
            // this.$nextTick(() => {
            //   this.$bvModal.show(
            //     `epm-bibliographic-resource-modal-${response.id}`
            //   );
            // });
          }
          this.createdMatStuEnvTimAlls(
            response,
            tmp_ep_mat_eva_stu_env_tim_alls
          );
          this.$bvModal.hide(
            `add-evaluation-modal-${this.egress_profile_matter_id}`
          );
        });
    },
    async createdMatStuEnvTimAlls(evaluation, tmp_ep_mat_eva_stu_env_tim_alls) {
      for await (let tmp_map_eva of tmp_ep_mat_eva_stu_env_tim_alls) {
        this.$restful
          .Post(`/mesh/egr-pro-mat-eva-stu-env-tim-all/`, {
            egress_profile_matter_evaluation: evaluation.id,
            study_environment: tmp_map_eva.study_environment,
            time_allocation: tmp_map_eva.time_allocation,
            hours: tmp_map_eva.hours,
          })
          .then((response) => {
            this.ep_mat_eva_stu_env_tim_all.push(response);
          });
      }
    },
    async bulkCreateTest(test_list, new_evaluation) {
      for await (let test of test_list) {
        if (isNaN(test.id)) {
          test.evaluation = new_evaluation.id;
          if (this.institution && this.institution.internal_use_id == "duoc.cl")
            test.title = new_evaluation.title;
          await this.$store
            .dispatch(names.POST_NEW_TEST, test)
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (!test.delete_test) {
          await this.$store
            .dispatch(names.PATCH_NEW_TEST, {
              new_test_id: test.id,
              item: {
                title: test.title,
                evaluation_situation: test.evaluation_situation,
                weighing: test.weighing,
                examiner: test.examiner,
                work_type: test.work_type,
              },
            })
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (test.delete_test) {
          await this.$store.dispatch(names.DELETE_NEW_TEST, test.id);
        }
      }
    },
    saveTestType(new_test) {
      if (new_test.test_type_default == null) {
        this.$restful
          .Post("/evaluations2/test-type-default/", {
            test: new_test.id,
            evaluative_agent: new_test.instrument_type.evaluative_agent,
          })
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      } else {
        this.$restful
          .Put(
            `/evaluations2/test-type-default/${new_test.test_type_default}/`,
            {
              test: new_test.id,
              evaluative_agent: new_test.instrument_type.evaluative_agent,
            }
          )
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      }
    },
    saveEvaluationTypeDefault(new_evaluation, evaluation_type) {
      if (evaluation_type) {
        if (new_evaluation.evaluation_type_default == null) {
          this.$restful
            .Post("/evaluations2/evaluation-type-default/", evaluation_type)
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        } else {
          this.$restful
            .Put(
              `/evaluations2/evaluation-type-default/${evaluation_type.id}/`,
              evaluation_type
            )
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        }
      }
    },
    updatedEvaluation(evaluation) {
      this.$restful
        .Put(
          `/teaching/egress-profile-matter-evaluation/${evaluation.id}/`,
          evaluation
        )
        .then((response) => {
          const index = this.profile_matters_evaluations.findIndex(
            (x) => x.id == response.id
          );
          if (index != -1) {
            this.profile_matters_evaluations.splice(index, 1, response);
            this.$bvModal.hide(`edit-evaluation-modal-${response.id}`);
          }
        });
    },
    fetchEvaluationSituations() {
      this.$restful
        .GetAll(`/teaching/evaluation-situation/`)
        .then((response) => {
          this.evaluation_situations = response;
        });
    },
    fetchProfileMattersEvaluation() {
      if (this.egress_profile_matter_id)
        this.$restful
          .GetAll(
            `/teaching/egress-profile-matter-evaluation/?egress_profile_matter=${this.egress_profile_matter_id}`
          )
          .then((response) => {
            if (this.canViewEvaluations) {
              const evaluations_ids = response
                .filter((x) => x.evaluation != null)
                .map((x) => x.evaluation);
              if (evaluations_ids.length > 0) {
                this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
                  evaluations_ids: evaluations_ids,
                });
                this.$store
                  .dispatch(names.FETCH_NEW_TESTS, {
                    evaluations_ids: evaluations_ids,
                  })
                  .then((tests) => {
                    this.fetchEvaluationsContent(tests);
                  });
              }
            }
            this.profile_matters_evaluations = response.sort(function (a, b) {
              if (a.order > b.order) return 1;
              if (a.order < b.order) return -1;
              return 0;
            });
            this.$nextTick(() => {
              this.tmp_key += 1;
            });
          });
    },
    fetchEpMatEvaStuEnvTimAll() {
      const time = setInterval(() => {
        this.$restful
          .GetAll(
            `/mesh/egr-pro-mat-eva-stu-env-tim-all/?egress_profile_matter=${this.egress_profile_matter_id}`
          )
          .then((response) => {
            this.ep_mat_eva_stu_env_tim_all = response;
          });
        clearInterval(time);
      }, 500);
    },
    // fetchLearningExperiences() {
    //   this.$restful
    //     .Get(`/teaching/learning-experience/?matter=${this.matter.matter}`)
    //     .then((response) => {
    //       this.learning_experiences = response.sort(function (a, b) {
    //         if (a.order > b.order) return 1;
    //         if (a.order < b.order) return -1;
    //         return 0;
    //       });
    //     });
    // },
  },
  mounted() {
    // if (this.matter) {
    //   this.fetchLearningExperiences();
    // }
  },
  created() {
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_TEST_WORK_TYPES);
    this.$store.dispatch(names.FETCH_EPM_EVALUATION_TYPES);
    this.$store.dispatch(names.FETCH_AUTONOMOUS_TEACHING_ACTIVITIES);
    this.fetchEpMatEvaStuEnvTimAll();
    this.fetchEvaluationSituations();
    // Evaluaciones -> tests -> instrumentos: solo para roles que gestionan
    // el programa (no PROFESORES/ESTUDIANTES). Un solo request por endpoint.
    if (this.canViewEvaluations) this.fetchProfileMattersEvaluation();
    this.$nextTick(() => {
      this.fetchAllMatterEpms();
    });
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
table th {
  vertical-align: middle;
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.evaluation-header {
  background: var(--kl-color-accent-medium) !important;
  border: 1px solid var(--kl-table-border) !important;
  color: var(--kl-text-on-primary);
}
.evaluation-button-div {
  float: right;
  /* padding-right: 1rem; */
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: left;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.grabbable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.ec-badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.ec-micro-badge {
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
  width: fit-content !important;
  margin-right: 0.3em;
  /* Badge alineado al estándar de chip suave (celeste + texto azul). */
  background: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  border-radius: var(--kl-radius-pill);
}
@media print {
  .ec-micro-badge {
    border: none;
  }

  /* Clases específicas para impresión */
  .print-nombre {
    width: 120px !important;
  }
  .print-instrumento {
    width: 100px !important;
  }
  .print-descripcion {
    width: auto !important;
    min-width: 200px !important;
  }
  .print-tipo {
    width: 60px !important;
  }
  .print-ponderacion {
    width: 80px !important;
  }
  .print-criterios {
    width: 100px !important;
  }

  /* Eliminar scroll y ajustar tablas para impresión */
  .table-responsive {
    overflow: visible !important;
  }

  .b-table-simple {
    overflow: visible !important;
    width: 100% !important;
  }

  /* Ajustar contenido de descripción */
  .description-evaluation {
    overflow: visible !important;
    max-height: none !important;
    word-wrap: break-word !important;
  }

  /* Ajustar tablas dentro de descripción */
  .description-evaluation table {
    width: 100% !important;
    table-layout: fixed !important;
    font-size: 10px !important;
  }

  .description-evaluation table td,
  .description-evaluation table th {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
    padding: 2px !important;
  }
}
</style>